import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=1acdcd3a&scoped=true"
import script from "./Submitted.vue?vue&type=script&lang=js"
export * from "./Submitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acdcd3a",
  null
  
)

export default component.exports